import { ReactComponent as BarChartEmptyState } from '../../../../src/insights/components/shared/images/EmptyBarChart.svg'
import { ThemedSVGImage } from './ThemedSVGImage'

export function EmptyBarChart() {
  return <ThemedSVGImage divProps={{ style: {} }} image={BarChartEmptyState} />
}
